import axios from 'axios';
import {
  COMMON_LOAD_PROJECT_DETAIL_BEGIN,
  COMMON_LOAD_PROJECT_DETAIL_SUCCESS,
  COMMON_LOAD_PROJECT_DETAIL_FAILURE,
  COMMON_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOAD_PROJECT_DETAIL_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_LOAD_PROJECT_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COMMON_LOAD_PROJECT_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailError() {
  return {
    type: COMMON_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_LOAD_PROJECT_DETAIL_BEGIN:
      return {
        ...state,
        loadProjectDetailPending: true,
        loadProjectDetailError: null,
      };

    case COMMON_LOAD_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: null,
        projectDetail: action.data,
      };

    case COMMON_LOAD_PROJECT_DETAIL_FAILURE:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: action.data.error,
      };

    case COMMON_LOAD_PROJECT_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailError: null,
      };

    default:
      return state;
  }
}
